import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TranslateLoaderService implements TranslateLoader {
  private readonly httpClient = inject(HttpClient);
  private readonly cacheBuster = Date.now();
  private readonly localhostHosts = new Set(['localhost', '127.0.0.1', '[::1]']);

  public getTranslation(language: string): Observable<Record<string, string>> {
    const translationBasePath = this.getTranslationBasePath();

    return this.httpClient.get<Record<string, string>>(
      `${translationBasePath}${language}.json?v=${this.cacheBuster}`
    );
  }

  private getTranslationBasePath(): string {    
    if (this.isLocalhost()) {
      return 'assets/i18n/';
    }
    return environment.translationFilePath;
  }

  private isLocalhost(): boolean {
    return this.localhostHosts.has(window.location.hostname);
  }
}
